import React, { Component } from "react";
import countryList from "react-select-country-list";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import actions from "../../../../redux/action";
import ProfileRender from "./children/ProfileRender";
import { requsetChangeProfile } from "../../../../api/apis";
import { message } from "antd";
import moment from "moment";
import i18n from "../../../../../../locales/i18n";
import { GAPersonalProfilePageDisplay } from "../../../../ga/personalCenter";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryList: countryList().getData(), //国家地区数组
      dataSource: [],
      changeInfoName: null, //用户当前修改的输入框名，用于显示提交按钮
      changeInfoLoading: false, //正在请求修改信息
    };
  }

  componentDidMount() {
    GAPersonalProfilePageDisplay();
  }

  handleSubmitBtnHide = form => {
    if (!form.isFieldsTouched(true)) {
      this.setState({
        changeInfoName: null,
      });
    }
  };

  /**
   *控制当前修改的表单的值
   * @param {*} changeInfoName
   */
  handleChangeInfoName = changeInfoName => {
    this.setState({
      changeInfoName,
    });
  };

  /**
   *点击提交信息按钮
   * @param {object} data 表单参数
   * @param {string} name 表单数据名称 email || name || birthday || country
   */
  handleClickChangeProfileBtn = (data, name) => {
    const { profileObj } = this.props;
    this.setState({
      changeInfoName: name,
      changeInfoLoading: true,
    });
    let formData = new FormData();
    let changeValue = "";
    if (name === "name") {
      changeValue = data.name;
      formData.append("nickname", changeValue);
      formData.append("location", profileObj.country ? profileObj.country : "CN");
      formData.append("birthday", profileObj.birthday ? profileObj.birthday : "1995-01-01");
    } else if (name === "country") {
      changeValue = data.country;
      formData.append("location", changeValue);
      formData.append("nickname", profileObj.nickname ? profileObj.nickname : "Anymous");
      formData.append("birthday", profileObj.birthday ? profileObj.birthday : "1995-01-01");
    } else if (name === "birthday") {
      changeValue = moment(data.birthday).format("YYYY-MM-DD");
      formData.append("birthday", changeValue);
      formData.append("nickname", profileObj.nickname ? profileObj.nickname : "Anymous");
      formData.append("location", profileObj.country ? profileObj.country : "CN");
    }
    this.handleRequestChangeProfile(formData, changeValue);
  };

  /**
   *请求修改用户信息
   * @param {object} data 参数
   * @param {string} changeValue 修改的值
   */
  handleRequestChangeProfile = (data, changeValue) => {
    console.log(data, changeValue);
    requsetChangeProfile({
      body: data,
    })
      .then(res => {
        if (res.code === 200) {
          message.success(this.props.t("updateSuccessTips"));
          let profileObj = { ...this.props.profileObj };
          switch (this.state.changeInfoName) {
            case "name":
              profileObj.nickname = changeValue;
              break;
            case "country":
              profileObj.country = changeValue;
              break;
            default:
              break;
          }
          this.props.onProfileObjChange(profileObj);
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          changeInfoName: "",
          changeInfoLoading: false,
        });
      });
  };

  /**
   *table 的表头
   */
  tableColumns = [
    {
      title: i18n.t("personalCenterProfile:tableProduct"),
      dataIndex: "product_name",
      key: "product",
    },
    {
      title: i18n.t("personalCenterProfile:tableStatus"),
      dataIndex: "status",
      key: "status",
      render: text => (text === "Active" ? i18n.t("personalCenterProfile:validStauts") : i18n.t("personalCenterProfile:expiredStauts")),
    },
    {
      title: i18n.t("personalCenterProfile:tablePermissionDate"),
      dataIndex: "create_time",
      key: "orderDate",
    },
    {
      title: i18n.t("personalCenterProfile:tableValidPeriod"),
      dataIndex: "active_Time",
      key: "validPeriod",
    },
  ];

  render() {
    return (
      <ProfileRender
        countryList={this.state.countryList}
        tableColumns={this.tableColumns}
        dataSource={this.props.subscription ? [this.props.subscription] : []}
        isVIP={this.props.subscription && this.props.subscription.status === "Active"}
        profileObj={this.props.profileObj}
        changeInfoName={this.state.changeInfoName}
        submitting={this.state.changeInfoLoading}
        handleChangeInfoName={this.handleChangeInfoName}
        handleClickChangeProfileBtn={this.handleClickChangeProfileBtn}
        handleSubmitBtnHide={this.handleSubmitBtnHide}
      />
    );
  }
}

const mapStateToPropos = state => ({
  profileObj: state.account.profileObj,
  subscription: state.account.subscription,
});
const mapDispatchToProps = dispatch => ({
  onProfileObjChange: profileObj => dispatch(actions.onProfileObjChange(profileObj)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(withTranslation(["common"])(Profile));
